// extracted by mini-css-extract-plugin
export default {"scrollDiv":"ExpenseList_scrollDiv__sxh+a","list":"ExpenseList_list__UqcFS"};